import React from "react";

function Contact() {
  return <h1 className="contact">Contact</h1>;
}

export default Contact;
